
import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '分類名稱',
    model: 'name',
    placeholder: '分類名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '是否開啟',
    model: 'enable',
    required: true,
    valueOn: 1,
    valueOff: 0,
  }
];

export default fields;
